<div class="relative flex min-h-screen">
    <!-- ================= DESKTOP SIDEBAR ================= -->
    <aside
        class="fixed top-0 bottom-0 left-0 z-50 hidden h-screen transition-all duration-300 md:block"
        [ngClass]="{
            'w-18': isSidebarCollapsed,
            'w-66': !isSidebarCollapsed,
        }">
        <app-sidebar-vendor [isCollapsed]="isSidebarCollapsed">
        </app-sidebar-vendor>
    </aside>

    <!-- Sidebar spacer to reserve width in document flow -->
    <div
        class="hidden h-screen shrink-0 transition-all duration-300 md:block"
        [ngClass]="{
            'w-18': isSidebarCollapsed,
            'w-66': !isSidebarCollapsed,
        }"></div>

    <!-- ================= MOBILE SIDEBAR ================= -->
    @if (isMobileSidebarOpen) {
        <div class="fixed inset-0 z-50 md:hidden">
            <!-- Overlay -->
            <div
                class="absolute inset-0 bg-black/30 backdrop-blur-[2px]"
                (click)="closeMobileSidebar()"></div>

            <!-- Drawer -->
            <div
                class="bg-surface absolute top-0 left-0 h-full w-62 transform shadow-xl transition-transform duration-300"
                [ngClass]="{
                    'translate-x-0': isMobileSidebarOpen,
                    '-translate-x-full': !isMobileSidebarOpen,
                }">
                <!-- CLOSE BUTTON (FLOATING) -->
                <button
                    (click)="closeMobileSidebar()"
                    class="border-border bg-surface text-text-primary hover:bg-surface-muted absolute top-3 right-3 z-50 flex h-9 w-9 items-center justify-center rounded-full border shadow-md transition">
                    <i class="pi pi-times text-text-primary text-base"></i>
                </button>

                <!-- SIDEBAR CONTENT -->
                <app-sidebar-vendor [isCollapsed]="false"></app-sidebar-vendor>
            </div>
        </div>
    }

    <!-- ================= MAIN CONTENT ================= -->
    <section
        class="bg-background-1 text-text-primary flex min-h-screen min-w-0 flex-1 flex-col overflow-x-hidden">
        <app-header-default
            (sidebarToggle)="toggleSidebar()"
            class="sticky top-0 z-40">
        </app-header-default>

        <main class="mx-auto w-full max-w-[1600px] flex-1 p-4 sm:p-6 lg:p-8">
            <ng-content></ng-content>
        </main>
    </section>
</div>
